import {
  Component,
  ContentChildren,
  Input,
  model,
  QueryList,
} from '@angular/core';
import { TabComponent } from './tab/tab.component';

@Component({
    selector: 'c-tabs',
    templateUrl: './tabs.component.html',
    styleUrl: './tabs.component.css',
    standalone: false
})
export class TabsComponent {
  @Input() loading = false;
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;

  activeIndex = model<number>(0);

  ngAfterContentInit() {
    const tabsArray = this.tabs.toArray();

    const activeIndex = tabsArray.findIndex((t) => t.active);
    this.activeIndex.set(activeIndex);

    if (this.activeIndex() === -1 && tabsArray[0]) {
      tabsArray[0].active = true;
    }
  }

  selectTab(index: number) {
    this.activeIndex.set(index);
    this.tabs.toArray().forEach((t, i) => (t.active = i === index));

    // auto-scroll
    const headers = document.querySelector('.tabs-header');
    const tabEl = headers?.children[index] as HTMLElement;

    if (headers && tabEl) {
      headers.scrollTo({
        left:
          tabEl.offsetLeft - headers.clientWidth / 2 + tabEl.clientWidth / 2,
        behavior: 'smooth',
      });
    }
  }
}
